<template>
  <div class="activeType">
    <!--  -->
    <div v-if="createStep == 1">
      <div class="activeType_top">
        <div class="content-left">
          <img
            :src="activityData.bghome"
            v-if="activityData.activityID != 8"
            style="width: 100%"
            alt=""
          />
          <el-carousel
            indicator-position="none"
            arrow="never"
            style="width: 100%;height: 100%;"
            v-else
          >
            <el-carousel-item
              style="height: 100%"
              v-for="item1 in activityData.imgList"
              :key="item1"
            >
              <img style="width: 100%;" :src="item1" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="content-right">
          <div class="sign">
            {{ activityData.title }}
            <span
              class="sign_jc"
              v-if="activityData.toUrl"
              @click="toUrl(activityData.toUrl)"
              style="cursor: pointer"
              >使用教程</span
            >
            <span class="sign_jc" v-else>使用教程</span>
          </div>
          <span class="sign_desc">{{ activityData.content }}</span>
          <div class="QRcode">
            <span style="border-radius: 20px">
              <div class="QRcode_img" id="QRcode_img" ref="QRcode_img"></div>
            </span>
            <span>淘宝APP扫码预览</span>
            <div class="QRcode_btn pointer" @click="handleRoute()">
              创建活动
            </div>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="tabSwitch">
        <div
          class="tabSwitch-wz"
          @click="handleTab(index)"
          v-for="(item, index) in tabSwitchList"
          :key="index"
          :class="{ active: index == currIndex }"
        >
          {{ item }}
        </div>
      </div>
      <template v-if="currIndex == 1">
        <tableAct @handleshow="handleshow" @copy="copyFn" />
      </template>
      <template v-if="currIndex == 0">
        <el-form
          v-if="false"
          ref="form"
          class="formClass"
          :model="form"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="模板名称：">
            <el-input style="" size="small" v-model="form.name"></el-input>
          </el-form-item>

          <el-form-item label="模板ID：">
            <el-input size="small" v-model="form.id"></el-input>
          </el-form-item>

          <div class="seach_btn">
            <el-button size="small" class="search"> 查询 </el-button>
            <el-button size="small" class="reset">重置</el-button>
          </div>
        </el-form>
        <!--  -->
        <div
          class="activeType_bottom"
          v-loading="loading"
          style="margin-top: 24px"
        >
          <div class="template">
            <div style="width: 75px; padding-top: 5px">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == tempIndex }"
                v-show="item.isVisible"
                @click="sellerImage(item.id, index, item.title)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div
              class="temImg"
              v-if="
                customUploadList.includes(Number($route.query.activityType)) &&
                tempTitle == '自定义上传'
              "
            >
              <div
                class="temImg_content"
                @click="handleTemDialog('new')"
                style="border: 1px solid rgba(38, 112, 251, 0.5)"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/upTem.svg" alt="" />
                    <span style="text-align: center; margin: 0">上传模板</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: rgba(38, 112, 251, 0.05)"
                ></div>
              </div>
            </div>
            <div class="temImg" v-else>
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid rgba(38, 112, 251, 0.5)"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: rgba(38, 112, 251, 0.05)"
                ></div>
              </div>
            </div>
            <!-- 模板 -->
            <div
              class="temImg"
              v-for="(item, index) in giftList"
              :key="item.templateId"
            >
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    class="imgs"
                    style="width: 100%"
                    :src="
                      activityTypeList.includes(
                        Number($route.query.activityType)
                      )
                        ? $route.query.activityType == 8 ||
                          $route.query.activityType == 19
                          ? item.fourPictureUrl
                          : copyParams.activityType == 37 ||
                            $route.query.activityType == 37
                          ? item.eightPictureUrl
                          : item.thankImageUrl
                        : item.templateExampleUrl
                    "
                    alt=""
                  />
                  <img
                    v-if="item.days"
                    class="temImg_content_img_free"
                    src="@/assets/images/free.svg"
                    alt=""
                    srcset=""
                  />
                  <div v-if="item.days" class="temImg_content_img_time">
                    倒计时：{{ item.days }}
                  </div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{
                    activityTypeList.includes(Number($route.query.activityType))
                      ? item.imageName
                      : item.templateName
                  }}</span>
                  <span class="temImg_desc">模板ID：{{ item.templateId }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="qrCodeIMG"
                  ref="qrCodeIMG"
                  :style="
                    customUploadList.includes(
                      Number($route.query.activityType)
                    ) && tempTitle == '自定义上传'
                      ? 'margin-top: 60px;'
                      : ''
                  "
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="handleSet(item, 1)"
                  :style="
                    customUploadList.includes(
                      Number($route.query.activityType)
                    ) && tempTitle == '自定义上传'
                      ? 'width: 136px;'
                      : ''
                  "
                >
                  使用此模板
                </div>
                <!-- 自定义上传 -->
                <div
                  v-if="
                    customUploadList.includes(
                      Number($route.query.activityType)
                    ) && tempTitle == '自定义上传'
                  "
                  class="temImg_content_bgshadow_editBtns"
                >
                  <div
                    class="temImg_content_bgshadow_edit pointer"
                    @click="handleTemDialog('edit', item)"
                  >
                    编辑模板
                  </div>
                  <div
                    class="temImg_content_bgshadow_edit pointer"
                    @click="deleteTemDialog(item)"
                  >
                    删除模板
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <statistics
      v-if="createStep == 3"
      @returnStep="returnStep"
      :rowData="rowData"
      :ids1="ids1"
    ></statistics>
    <createAct
      v-if="createStep == 2"
      @goBack="back"
      :copyParams="copyParams"
    ></createAct>
    <templateDialog
      v-if="isTemplateDialog"
      :isShow="isTemplateDialog"
      :activityType="Number($route.query.activityType)"
      :templateDialogType="templateDialogType"
      :temId="temId"
      :templateGroupId="templateGroupId"
      @onSave="saveTemplate"
      @onClose="isTemplateDialog = false"
    ></templateDialog>
    <integral-mall-decoration
      v-if="createStep == 'decoration'"
      @returnStep="returnStep"
    ></integral-mall-decoration>
  </div>
</template>

<script>
import tableAct from "./tableAct.vue";
import statistics from "../integralCenter/activity_data_statistics.vue";
import createAct from "../huodongedit/index.vue";
import templateDialog from "@/components/templateDialog.vue";
import integralMallDecoration from "./integralMallDecoration.vue";
import giftTmp from "../../mixin/giftTmp.js";
export default {
  name: "activeType",
  mixins: [giftTmp],
  components: {
    tableAct,
    statistics,
    createAct,
    templateDialog,
    integralMallDecoration,
  },
  data() {
    return {
      statisticsShow: 1,
      form: {
        name: "",
        id: "",
      },
      copyParams: {},
      tabSwitchList: ["玩法模板", "活动管理"],
      currIndex: 0,
      createStep: 1,
      ids1: "",
      rowData: {},
      // tempIndex: 0,
      // tempSwitchList: ["全部", "618", "双11", "双12"],
      // activityData: {},
    };
  },
  created() {
    console.log("222------>", 222);
    // 埋点
    this.buriedPoint(
      1,
      "云起互动",
      this.activityData.secondaryMenuName,
      this.activityData.title
    );
    let goIndex = sessionStorage.getItem("goBack");
    if (sessionStorage.getItem("goBackCopy")) {
      sessionStorage.removeItem("goBackCopy");
      goIndex = 1;
    }
    console.log("goIndex------>", goIndex);
    if (goIndex) {
      if (goIndex == 1) this.currIndex = 1;
      if (goIndex == 2) this.createStep = 2;
    }
  },
  methods: {
    // 创建活动
    handleRoute() {
      this.copyParams = {};
      this.createStep = 2;
      // let params = {
      //   activityID: this.activityData.activityID,
      //   title: this.activityData.title,
      //   activityData: {
      //     name: this.activityData.title,
      //     id: this.activityData.activityID,
      //   },
      // };
      // this.$router.push({ path: "activeEdit", query: params });
    },

    copyFn(val) {
      this.copyParams = { ...val, isCopy: true };
      this.createStep = 2;
    },

    // tab切换
    handleTab(i) {
      this.currIndex = i;
      if (i == 0) {
        this.$nextTick(() => {
          if (
            this.activityTypeList.includes(
              Number(this.$route.query.activityType)
            )
          ) {
            this.getCodeIMGList();
          } else {
            this.getCodeIMG();
          }
        });
      }
    },
    handleshow(row) {
      // this.statisticsShow = 2;
      if (row.isShowIntegral) {
        this.createStep = "decoration";
      } else {
        this.rowData = row.row;
        this.ids1 = row.id;
        this.createStep = 3;
      }
    },
    returnStep() {
      this.createStep = 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    back() {
      this.createStep = 1;
      this.$nextTick(() => {
        if (
          this.activityTypeList.includes(Number(this.$route.query.activityType))
        ) {
          this.getCodeIMGList();
        } else {
          this.getCodeIMG();
        }
      });
    },
    toUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .QRcode_img {
  padding: 5px;
  img {
    border-radius: 1px;
  }
}
.activeType {
  // width: 98%;
  margin: 24px;
  padding: 24px;
  min-height: 1062px;
  background: #ffffff;
  &_top {
    display: flex;
    .content-left {
      width: 184px;
      height: 336px;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #ffffff;
      margin-bottom: 40px;
      overflow: hidden;
      /deep/.el-carousel__container{
        height: 100%;
      }
    }
    .content-right {
      flex: 1;
      margin-left: 33px;
      margin-top: 16px;
    }
    .sign {
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      margin-bottom: 12px;
      display: flex;
      align-items: end;
      &_jc {
        font-size: 14px;
        color: #999999;
        margin-left: 20px;
        display: flex;
        &::before {
          content: "";
          width: 15px;
          height: 15px;
          margin-right: 4px;
          background: url("../../assets/thdImg/pages/question.svg") no-repeat;
        }
      }
    }
    .sign_desc {
      font-size: 14px;
      color: #666666;
    }
    .QRcode {
      width: 150px;
      height: 150px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #000000;
      margin-top: 50px;
      &_img {
        width: 100%;
        height: 162px;
        // background: #2670fb;
        box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #ffffff;
        margin-bottom: 10px;
      }
      &_btn {
        width: 96px;
        height: 32px;
        // line-height: 32px;
        // text-align: center;
        background: #2670fb;
        border-radius: 4px 4px 4px 4px;
        margin-top: 24px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        &::before {
          content: "";
          width: 19px;
          height: 19px;
          margin-right: 5px;
          background: url("../../assets/thdImg/pages/create.svg") no-repeat;
        }
      }
    }
  }
  .tabSwitch {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    // padding: 0 20px;
    position: relative;
    height: 50px;
    font-size: 14px;
    color: #666;
    border-bottom: 1px solid #f6f6f6;
    &-wz {
      height: 50px;
      line-height: 50px;
      position: relative;
      margin-right: 24px;
      cursor: pointer;
      transition: all 0.2s;
    }
    .active {
      color: #2670fb;
      &::before {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 100%;
        height: 2px;
        background-color: #2670fb;
        transition: all 0.2s;
        animation: opation 0.2s;
      }
      @keyframes opation {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 100%;
        }
      }
    }
  }
  .formClass {
    margin: 24px 0;
    display: flex;
    /deep/.el-form-item {
      margin-right: 50px;
    }
    .seach_btn {
      margin-left: auto;
      margin-right: 30px;
      display: flex;
    }
    .search,
    .reset {
      width: 98px;
      font-size: 14px;
      height: 32px;
      transition: all 0.2s;
      border-radius: 4px 4px 4px 4px;
    }
    .search {
      color: #fff;
      background-color: #2670fb;
      &:hover {
        opacity: 0.8;
      }
    }
    .reset {
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #2670fb;
        border: 1px solid #2670fb;
        background: rgba(38, 112, 251, 0.1);
      }
    }
  }
  &_bottom {
    .template {
      display: flex;
      color: #333333;
      // align-items: center;
      margin-bottom: 16px;
      &-nav {
        display: flex;
        flex-wrap: wrap;
      }
      &-wz {
        padding: 4px 8px;
        color: #666666;
        background: #f8f8fb;
        border-radius: 4px;
        margin-left: 12px;
        margin-bottom: 10px;
        &:hover {
          background: #2670fb;
          border-radius: 4px;
          color: #ffffff;
        }
      }
      .activeTem {
        background: #2670fb;
        border-radius: 4px;
        color: #ffffff;
      }
    }
    .templateBox {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    .temImg {
      width: 224px;
      height: 453px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-right: 41px;
      &:hover .temImg_content_bgshadow {
        opacity: 0;
        animation: key3 0.5s forwards;
      }
      @keyframes key3 {
        0% {
          opacity: 0;
        }
        50% {
          opacity: 0.3;
        }
        100% {
          opacity: 1;
        }
      }
      .temImg_content_bgshadow {
        z-index: 123;
        opacity: 0;
        position: absolute;
        // left: -1;
        top: 10px;
        width: 100%;
        height: 380px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 8px 8px 0px 0px;
        transform: scale(1.05);
        &_code {
          margin: 0 auto;
          margin-top: 125px;
          width: 150px;
          height: 150px;
          background: #ffffff;
          border-radius: 4px;
        }
        &_codeDesc {
          margin: 0 auto;
          margin-top: 15px;
          width: 112px;
          color: #ffffff;
        }
        &_btn {
          margin: 0 auto;
          margin-top: 25px;
          margin-bottom: 8px;
          width: 86px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background: #2670fb;
          border-radius: 4px;
          color: #ffffff;
        }
        &_editBtns {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 136px;
          margin: 0 auto;
        }
        &_edit {
          margin: 0 auto;
          width: 64px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          font-weight: 400;
          font-size: 12px;
          color: #2670fb;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
        }
      }
      &_content {
        width: 100%;
        height: 433px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        transition: 0.6s linear;
        &_img {
          width: 100%;
          height: 380px;
          border-radius: 8px 8px 0px 0px;
          // background: #666;
          background: rgba(38, 112, 251, 0.05);
          // transition: 0.6s linear;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &_wz {
          width: 100%;
          height: 53px;
          padding: 10px 12px;
        }
      }

      &:hover {
        .temImg_content {
          box-shadow: 0px 12px 25px 1px rgba(0, 0, 0, 0.15);
          border-radius: 8px;
          transform: scale(1.05);
          transition: transform 0.3s, -webkit-transform 0.3s;
        }
      }
      &_dz {
        width: 100%;
        // height: 433px;
        display: flex;
        justify-content: center;
        align-items: center;
        &_center {
          > img {
            margin: 0 auto;
            display: block;
          }
          > span {
            font-size: 20px;
            font-weight: bold;
            margin-top: 12px;
            display: block;
          }
        }
      }
      &_title {
        display: block;
        color: #333333;
      }
      &_desc {
        display: block;
        font-size: 12px;
        line-height: 23px;
        color: #999;
      }
    }
    @media screen and (min-width: 1350px) and (max-width: 1700px) {
      .temImg {
        margin-right: 26px !important;
      }
    }
  }
}
</style>
